const isBrowser = (): boolean => typeof window !== "undefined";

const COOKIE_NAME = "wealthx_company_id";
const COOKIE_DOMAIN = process.env.GATSBY_SHARED_COOKIE_DOMAIN || "";
const IS_SECURE = !COOKIE_DOMAIN.includes("localhost");
const MAX_AGE = 31536000;

export const setCompanyIdCookie = (companyId: string): void => {
  if (!isBrowser() || !companyId) return;
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(companyId)}`,
    `path=/`,
    `max-age=${MAX_AGE}`,
    `SameSite=Lax`,
  ];
  if (COOKIE_DOMAIN) parts.push(`domain=${COOKIE_DOMAIN}`);
  if (IS_SECURE) parts.push("Secure");
  document.cookie = parts.join("; ");
};

export const getCompanyIdCookie = (): string | null => {
  if (!isBrowser()) return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
};

export const removeCompanyIdCookie = (): void => {
  if (!isBrowser()) return;
  const parts = [
    `${COOKIE_NAME}=`,
    `path=/`,
    `max-age=0`,
    `expires=Thu, 01 Jan 1970 00:00:00 GMT`,
    `SameSite=Lax`,
  ];
  if (COOKIE_DOMAIN) parts.push(`domain=${COOKIE_DOMAIN}`);
  if (IS_SECURE) parts.push("Secure");
  document.cookie = parts.join("; ");
};
